import { RadioGroup, RadioGroupChangeEvent } from '@progress/kendo-react-inputs';
import clsx from 'clsx';
import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { ManageSupplierStatus } from 'src/types/manage-suppliers/ManageSupplier';

interface SupplierStatusFieldProps {
  value: ManageSupplierStatus;
  onChange: (value: ManageSupplierStatus) => void;
  readOnly?: boolean;
  className?: string;
}

const SupplierStatusField: FC<SupplierStatusFieldProps> = ({
  value,
  onChange,
  readOnly = false,
  className,
}) => {
  const { t } = useTranslation();

  const statusOptions = useMemo(
    () => [
      { label: t('Active'), value: 'active' as const },
      { label: t('Inactive'), value: 'inactive' as const },
      { label: t('Archived'), value: 'archived' as const },
    ],
    [t]
  );

  const statusLabel = useMemo(() => {
    const match = statusOptions.find((option) => option.value === value);
    return match?.label ?? value;
  }, [statusOptions, value]);

  return (
    <div className={clsx('supplier-form__transmission-type flex flex-col gap-2', className)}>
      <span className="text-sm text-gray-500">{t('Status')}</span>
      {readOnly ? (
        <span className="supplier-form__field-value">{statusLabel}</span>
      ) : (
        <RadioGroup
          data={statusOptions}
          value={value}
          onChange={(event: RadioGroupChangeEvent) => {
            onChange(event.value as ManageSupplierStatus);
          }}
          layout="horizontal"
        />
      )}
    </div>
  );
};

export default SupplierStatusField;
